import type { PaginatedMeta, PaginationParams } from './client';
import { request, toQuery } from './client';

export type Client = {
	id: number;
	first_name: string;
	last_name: string;
	name: string;
	email: string;
	phone: string | null;
	status: string;
	notes: string | null;
	timezone: string | null;
	created_at: string;
	updated_at: string | null;
	is_demo: boolean;
};

export type ClientsListResponse = PaginatedMeta & { clients: Client[] };

export type ClientsListParams = PaginationParams & {
	search?: string;
};

export type CreateClientData = {
	first_name?: string;
	last_name?: string;
	email: string;
	phone?: string;
	notes?: string;
	status?: string;
	timezone?: string;
};

export type UpdateClientData = Partial<CreateClientData>;

export type ClientBulkAction = 'delete';

export type ClientBulkResult = {
	action: ClientBulkAction;
	processed: number;
	failed: number;
	results: Array<{ id: number; success: boolean; error?: string }>;
};

export const clientsApi = {
	list: (params?: ClientsListParams) =>
		request<ClientsListResponse>('/clients' + toQuery(params)),

	get: (id: number) => request<Client>(`/clients/${id}`),

	create: (data: CreateClientData) =>
		request<Client>('/clients', { method: 'POST', data }),

	update: (id: number, data: UpdateClientData) =>
		request<Client>(`/clients/${id}`, { method: 'PUT', data }),

	delete: (id: number) =>
		request<{ deleted: boolean }>(`/clients/${id}`, { method: 'DELETE' }),

	bulk: (action: ClientBulkAction, ids: number[]) =>
		request<ClientBulkResult>('/clients/bulk', {
			method: 'POST',
			data: { action, ids },
		}),
};
